import { motion } from "framer-motion";

const ProductShowcase = () => {
  return (
    <div className="bg-black text-white lg:pt-10 flex items-center justify-center px-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl items-center">
        {/* Left Section */}
        <motion.div
          className="space-y-4"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-sm uppercase text-white tracking-wide">Introducing</p>
          <h1 className="text-4xl md:text-5xl font-bold text-green-500">Zoap</h1>
          <p className="text-lg leading-relaxed text-white">
            Zoap is a perfectly balanced hybrid strain known for its fruity aroma and uplifting effects. It provides a smooth, euphoric high that enhances creativity and relaxation, making it ideal for both day and night use.
          </p>
          <hr className="border-green-500 w-1/3" />
        </motion.div>

        {/* Center Section with Hover Effects */}
        <motion.div
          className="flex items-center justify-center"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
        >
          <motion.img
            src="/images/zoap.png"
            alt="Zoap Cannabis"
            className="rounded-lg shadow-lg max-w-full h-auto"
            whileHover={{
              scale: 1.1,
              rotate: 5,
              boxShadow: "0px 10px 20px rgba(0, 255, 128, 0.5)",
            }}
            transition={{
              duration: 0.4,
              ease: "easeInOut",
            }}
          />
        </motion.div>

        {/* Right Section */}
        <motion.div
          className="flex flex-col items-center space-y-4"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="space-y-2 text-sm md:text-base w-full">
            <p className="flex justify-between border-b border-orange-700 py-2">
              <span>LINEAGE</span>
              <span className="text-orange-400">Rainbow Sherbet x Pink Guava</span>
            </p>
            <p className="flex justify-between border-b border-orange-700 py-2">
              <span>BREEDER</span>
              <span className="text-orange-400">DEO Farms</span>
            </p>
            <p className="flex justify-between border-b border-orange-700 py-2">
              <span>THC</span>
              <span className="text-orange-400">22 – 26%</span>
            </p>
            <p className="flex justify-between border-b border-orange-700 py-2">
              <span>TERPENES</span>
              <span className="text-orange-400">2.0 – 2.5%</span>
            </p>
            <p className="flex justify-between border-b border-orange-700 py-2">
              <span>DOMINANT</span>
              <span className="text-orange-400">Limonene, Linalool, Caryophyllene</span>
            </p>
            <p className="flex justify-between py-2">
              <span>NOSE</span>
              <span className="text-orange-400">Fruity, Citrus, Creamy</span>
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ProductShowcase;